export default {
  selectedWithCount: '{number}個{contentName}を選択',
  shareEntireDirectory: 'ディレクトリ全体を共有',
  afterOpenTips:
    '有効にすると、ディレクトリ内のすべてのコンテンツが共有されます\n（このディレクトリに将来追加されるコンテンツも自動的に共有されます）',
  afterOpenTipsTwo:
    'ディレクトリ内のすべてのコンテンツが共有されます（このディレクトリに将来追加されるコンテンツも自動的に共有されます）',
  noContent: 'データがありません',
  selectAll: 'すべて選択',
  all: 'すべて',
  notSelectAnyWithName: `{name}が選択されていません`,
  cancel: 'キャンセル',
  confirm: '確認',
  customExpression: 'カスタム式',
  noPermission: '権限がありません',
  enumeratedValue: '列挙値',
  description: '説明',

  required: '必須',
  optional: 'オプション',
  default: 'デフォルト値',
  length: '長さ',
  format: 'データフォーマット',
  enum: '列挙',
  regexp: '正規表現',
  and: 'そして',
  value: '値',
  arrayLength: '長さ',
  uniqueItems: '要素の一意性',
  const: '定数',
  multipleOf: '{multipleOf}の倍数',
  propertiesLength: 'プロパティの数',
  additionalItems: '追加アイテム',
  additionalProperties: '追加プロパティ',
  writeOnly: '書き込みのみ',
  readOnly: '読み取り専用',
  examples: 'サンプル値',
  externalDocs: '外部ドキュメント',
  isCopied: 'コピー済み',
  copyToClipboard: 'クリックしてコピー',
  'overView.isCopied': 'コピー済み',
  'overView.failToCopied': 'コピーに失敗しました。手動でコピーしてください。',
  'component.tagSelect.expand': '展開',
  'component.tagSelect.collapse': '折りたたむ',
  deprecated: '廃止予定',
  'error.url': 'URLの形式が間違っています：{url}',
  note: '注意',
  tip: 'ヒント',
  info: '情報',
  caution: '注意',
  danger: '危険',
  warning: '警告',
  check: '確認',
  name: '名前',
  'codeEditor.copy': 'コピー',
  'codeEditor.format': '整形',
  'codeEditor.showEditor': 'コンテンツを表示',

  'schemaGenerator.code': 'コード',
  'schemaGenerator.codeGenerate': 'Schemaコードを生成する',
  'schemaGenerator.more': 'その他',
  'schemaGenerator.name': 'Schema名',
  'schemaGenerator.commaSeparator': '、',
  'codeEditor.wrap': '自動改行',

  'inbox.MarkAllAsRead': '全て既読',

  // markdown embed
  'githubGistRenderer.loading.message': 'Loading gist',
  'githubGistRenderer.errorLoading.message': 'gistの読み込み中にエラーが発生しました',
  'environment.manageModal.tip.clickToSetVariable': '変数を設定するには、クリックしてください：',
  'environment.variable.notSet': '未設定',

  'httpCode.shortName.200': 'OK',
  'httpCode.shortName.201': '作成済み',
  'httpCode.shortName.202': '承認済み',
  'httpCode.shortName.204': '内容なし',
  'httpCode.shortName.400': '不正な要求',
  'httpCode.shortName.401': '権限なし',
  'httpCode.shortName.403': 'アクセス禁止',
  'httpCode.shortName.404': 'レコードが存在しない',
  'httpCode.shortName.410': 'レコードが存在しない',
  'httpCode.shortName.422': 'パラメータエラー',
  'httpCode.shortName.500': 'サーバーエラー',
  'httpCode.shortName.502': 'ゲートウェイエラー',
  'httpCode.shortName.503': 'サーバー障害',
  'httpCode.shortName.504': 'ゲートウェイタイムアウト',
};
